<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/call/dashboard" text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ claim === 1 ? 'Personal Ride' : 'Book a Ride' }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form #myForm="ngForm" [formGroup]="formCall" class="form">
    <ion-row>
      <ion-col grid-6>
        <ion-item>
          <ion-label position="floating">Passenger</ion-label>
          <ion-input
            type="text"
            formControlName="nome"
            [attr.readonly]="this.claim === userType.Passenger"
          ></ion-input>
        </ion-item>
      </ion-col>
      <ion-col grid-6>
        <ion-item>
          <ion-label position="floating">Cell Phone</ion-label>
          <ion-input
            type="tel"
            formControlName="celular"
            [attr.readonly]="this.claim === userType.Passenger"
          ></ion-input>
        </ion-item>
      </ion-col>
    </ion-row>
    <div class="box-search-destiny">
      <div class="divider"></div>
      <input
        id="origins"
        class="input origin"
        type="search"
        placeholder="Origin"
        formControlName="origem"
        autocomplete
      />
      <input
        id="places"
        class="input"
        type="search"
        placeholder="Where to?"
        formControlName="destino"
        autocomplete
        [(ngModel)]="searchDestiny"
        (ngModelChange)="getItems($event)"
      />
      <div
        class="list-complete"
        *ngIf="
          searchDestiny !== '' &&
          listDestiny.length &&
          autoCompleteEnabled &&
          (isTour || isPackage)
        "
      >
        <div
          class="item"
          *ngFor="let destiny of listDestiny"
          (click)="changeDestiny(destiny); autoCompleteEnabled = false"
        >
          <ion-icon name="pin"></ion-icon>
          {{ destiny.nomeRua + " - " + destiny.bairro + " - " + destiny.cidade
          }}
        </div>
      </div>
    </div>
    <ion-row>
      <ion-col grid-8>
        <div class="block-check" style="display: block">
          <span class="hero-label">Estimated Trip</span>
          <ion-label class="hero-item" *ngIf="showTrip"
            >{{ raceValue }}</ion-label
          >
          <ion-label class="hero-item" *ngIf="!showTrip"
            >Calculating price</ion-label
          >
        </div>
      </ion-col>
      <ion-col grid-4 style="display: none">
        <div class="block-check">
          <ion-checkbox
            slot="end"
            #tourCheck
            (ionChange)="checktypeTour()"
            formControlName="destino_fixo0"
          ></ion-checkbox>
          <ion-label><strong>Tours</strong></ion-label>
        </div>
        <div class="block-check">
          <ion-checkbox
            slot="end"
            #packageCheck
            (ionChange)="checktypePackage()"
            formControlName="destino_fixo1"
          ></ion-checkbox>
          <ion-label><strong>Packages</strong></ion-label>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <!-- <ion-col size="6">
        <ion-card
          class="trip-type-card"
          (click)="toggleSelectLanguage()"
          [ngClass]="{'selected': selectLanguage}"
        >
          <ion-card-header>
            <ion-card-subtitle style="text-align: center"
              >Language</ion-card-subtitle
            >
          </ion-card-header>
          <ion-card-content
            style="
              padding: 0;
              border-radius: 10px;
              display: flex;
              justify-content: center;
            "
          >
            <ion-img
              alt="Driver's language"
              src="assets/images/language.png"
              class="d-ico"
            />
          </ion-card-content>
        </ion-card>
      </ion-col> -->
      <ion-col size="6">
        <ion-card
          class="trip-type-card"
          (click)="checkTour()"
          [ngClass]="{'selected': isTour}"
        >
          <ion-card-header>
            <ion-card-subtitle style="text-align: center"
              >Tours</ion-card-subtitle
            >
          </ion-card-header>
          <ion-card-content
            style="
              padding: 0;
              border-radius: 10px;
              display: flex;
              justify-content: center;
            "
          >
            <ion-img alt="Tour" src="assets/images/tour.png" class="d-ico" />
          </ion-card-content>
          <p class="trip-type-desc">Guided tours and city experiences</p>
        </ion-card>
      </ion-col>
      <ion-col size="6">
        <ion-card
          class="trip-type-card"
          (click)="checkPackage()"
          [ngClass]="{'selected': isPackage}"
        >
          <ion-card-header>
            <ion-card-subtitle style="text-align: center"
              >Packages</ion-card-subtitle
            >
          </ion-card-header>
          <ion-card-content
            style="
              padding: 0;
              border-radius: 10px;
              display: flex;
              justify-content: center;
            "
          >
            <ion-img
              alt="Package"
              src="assets/images/package.png"
              class="d-ico"
            />
          </ion-card-content>
          <p class="trip-type-desc">Bundle experiences and services</p>
        </ion-card>
      </ion-col>
    </ion-row>
    <div class="ion-padding">
      <app-carrousel-cars
        *ngIf="claim === 0 || claim === 2"
        (carTypeChanged)="carTypeChanged($event)"
        [controlForm]="formCall.get('veiculo')"
      ></app-carrousel-cars>
      <ion-item *ngIf="(claim === 0 || claim === 2)">
        <ion-label position="floating">Driver's Language</ion-label>
        <ion-select [value]="language" multiple formControlName="idiomas">
          <ion-select-option
            *ngFor="let language of languages"
            [value]="language.value"
            [disabled]="checkValue(language)"
          >
            {{ language.label }}
          </ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item lines="none" *ngIf="horasEsperaConfig.limiteHoras > 0">
        <ion-icon name="time-outline" slot="start"></ion-icon>
        <ion-label>Add waiting hours</ion-label>
        <ion-toggle
          slot="end"
          [checked]="showHorasEsperaPicker"
          (ionChange)="toggleHorasEspera($event)"
        ></ion-toggle>
      </ion-item>

      <app-waiting-hours-picker
        *ngIf="showHorasEsperaPicker && horasEsperaConfig.limiteHoras > 0"
        [limiteHoras]="horasEsperaConfig.limiteHoras"
        [valorHora]="horasEsperaConfig.valorHora"
        [selectedHours]="formCall.get('horasEspera').value"
        (horasChanged)="onHorasEsperaChanged($event)"
      ></app-waiting-hours-picker>

      <app-type-race
        (sendDateSchedule)="setRaceSchedule($event)"
        [controlForm]="formCall.get('tipo_corrida')"
        (sendRaceType)="setTripType($event)"
      ></app-type-race>
      <ion-row>
        <ion-col grid-12>
          <ion-item>
            <ion-icon name="pricetag-outline" slot="start" class="coupon-icon"></ion-icon>
            <ion-label position="floating">Coupon</ion-label>
            <ion-input
              type="text"
              formControlName="coupon"
              (focusout)="checkValidCoupon($event)"
            ></ion-input>
          </ion-item>
        </ion-col>
      </ion-row>
      <div
        class="block-date"
        *ngIf="
          formCall.get('horario_agendado').value &&
          formCall.get('tipo_corrida').value === 2
        "
      >
        <ion-icon name="calendar"></ion-icon>
        Trip scheduled for {{ formCall.get("horario_agendado").value | date:
        "medium" }}
      </div>

      <div class="comment-box" *ngIf="formCall.get('comentario').value">
        <ion-label position="floating">Comment</ion-label>
        <div class="block">
          <ion-icon name="chatbubbles"></ion-icon>
          {{ formCall.get("comentario").value }}
        </div>
      </div>

      <footer class="ion-padding-top ion-padding-bottom" *ngIf="claim === 1">
        <ion-button
          class="ion-margin-top"
          [disabled]="
            formCall.invalid ||
            searchingDriver
          "
          color="primary"
          expand="full"
          shape="round"
          (click)="callDriver()"
          >Start
        </ion-button>
      </footer>
      <footer
        class="ion-padding-top ion-padding-bottom"
        *ngIf="claim === 0 || claim === 2"
      >
        <ion-radio-group
          [formControl]="formCall.controls.forma_pagamento"
          class="ion-margin-bottom"
        >
          <ion-list lines="none">
            <ion-item *ngIf="isCashAllowed()">
              <ion-label>Pay with cash</ion-label>
              <ion-radio slot="start" value="cash"></ion-radio>
            </ion-item>
            <ion-item>
              <ion-label>Pay with Stripe link (≥48h)</ion-label>
              <ion-radio slot="start" value="stripe"></ion-radio>
            </ion-item>
          </ion-list>
          <div
            *ngIf="!isCashAllowed()"
            class="ion-text-center ion-padding-bottom"
          >
            <small>
              This ride is scheduled more than 48 hours ahead, so prepayment via
              Stripe link is required.
            </small>
          </div>
        </ion-radio-group>

        <!-- Stripe link path: only valid for rides scheduled ≥48h out -->
        <div *ngIf="formCall.get('forma_pagamento').value === 'stripe'">
          <div *ngIf="isRideMoreThan48Hours()">
            <ion-button
              class="ion-margin-top"
              [disabled]="formCall.invalid || searchingDriver"
              color="success"
              expand="full"
              shape="round"
              (click)="bookAndGenerateLink()"
            >
              <ion-icon name="card-outline" slot="start"></ion-icon>
              Book &amp; Generate Link
            </ion-button>
            <ion-button
              class="ion-margin-top"
              [disabled]="formCall.invalid || searchingDriver"
              color="primary"
              expand="full"
              shape="round"
              (click)="saveRideForPayment()"
            >
              <ion-icon name="bookmark-outline" slot="start"></ion-icon>
              Save for later
            </ion-button>
          </div>
          <div *ngIf="!isRideMoreThan48Hours()" class="ion-text-center ion-padding">
            <small>
              Stripe link requires scheduling at least 48 hours ahead. Choose
              Cash to dispatch immediately or for same-day schedule.
            </small>
          </div>
        </div>

        <!-- Cash path: dispatch immediately or same-day schedule via SignalR -->
        <div *ngIf="formCall.get('forma_pagamento').value === 'cash' && isCashAllowed()">
          <ion-button
            class="ion-margin-top"
            [disabled]="formCall.invalid || searchingDriver"
            color="primary"
            expand="full"
            shape="round"
            (click)="callDriver()"
            >Book a Ride
          </ion-button>
        </div>
      </footer>
    </div>
    <div class="modal-observation" [ngClass]="{ open: commentsEnable }">
      <div class="ion-padding container-flex">
        <button class="bt-close">
          <ion-icon
            name="close-circle"
            (click)="
              commentsEnable = false; formCall.get('comentario').setValue('')
            "
          ></ion-icon>
        </button>

        <div class="header">
          <h2 class="title">
            <ion-icon name="chatbubbles"></ion-icon> Add a comment <br />
            to this trip
          </h2>
        </div>

        <div class="container-textarea">
          <textarea
            formControlName="comentario"
            class="textarea-default"
            placeholder="Insert your comment..."
          ></textarea>
        </div>

        <button
          (click)="commentsEnable = false"
          class="ion-margin-top button-bigger animation-none"
          expand="full"
        >
          OK
        </button>
      </div>
    </div>
  </form>
  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button color="dark" (click)="openComment()">
      <ion-icon name="chatbox"></ion-icon>
    </ion-fab-button>
  </ion-fab>
  <app-modal-component
    #shareModal
    *ngIf="foundNoDriversSchedule || acceptedTrip"
    (stateOpen)="foundNoDrivers = $event || acceptedTrip = $event"
  >
    <div class="information-booking text-center" #reservationInfo>
      <h2 class="title">{{ getModalTitle() }}</h2>
      <ion-icon
        name="checkmark-circle"
        class="ico"
        *ngIf="acceptedTrip"
        style="font-size: 65px"
      ></ion-icon>
      <ion-icon
        name="hourglass-outline"
        class="ico"
        *ngIf="foundNoDriversSchedule"
        style="font-size: 65px; color: #1a2d55"
      ></ion-icon>
      <p style="font-size: 13px">{{ getNote() }}</p>
      <div class="container">
        <ul style="text-align: justify; font-size: 13px">
          <li>
            Date and Time: {{raceRequest.scheduledRaceDate | date: "MM/dd/yyyy
            h:mm a"}}
          </li>
          <li>Pickup: {{raceRequest.enderecoOrigem}}</li>
          <li>Drop off: {{raceRequest.enderecoDestino}}</li>
        </ul>
        <ul *ngIf="acceptedTrip" style="text-align: justify; font-size: 13px">
          <li>Driver: {{acceptedTripInfo.motorista.nome}}</li>
          <li>Plate: {{acceptedTripInfo.motorista.veiculo.placa}}</li>
          <li>Color: {{acceptedTripInfo.motorista.veiculo.cor}}</li>
          <li>
            Car: {{acceptedTripInfo.motorista.veiculo.ano}}
            {{acceptedTripInfo.motorista.veiculo.marca}}
            {{acceptedTripInfo.motorista.veiculo.modelo}}
          </li>
        </ul>
        <ul style="text-align: justify; font-size: 13px">
          <li>Passenger: {{raceRequest.passengerName}}</li>
          <li>Phone Number: {{raceRequest.telephoneNumber}}</li>
        </ul>
        <p style="font-size: 13px">{{ getBodyNote() }}</p>
      </div>
    </div>
    <ion-button
      *ngIf="isSharing"
      class="ion-margin-top"
      color="medium"
      expand="full"
      >Sharing, please wait...</ion-button
    >
    <ion-button
      *ngIf="!isSharing"
      class="ion-margin-top"
      color="success"
      expand="full"
      (click)="shareReserv()"
      >Share</ion-button
    >
    <ion-button
      *ngIf="!isSharing"
      class="ion-margin-top"
      color="medium"
      expand="full"
      (click)="gotoHome()"
      >Go To Home</ion-button
    >
  </app-modal-component>
</ion-content>
